/*
 * Pagina collezione, impostazione "Navigazione tra i prodotti" della sezione collection-template:
 *
 * - "Pulsante Mostra altri": il click sul pulsante aggiunge in fondo alla griglia i prodotti della
 *   pagina successiva, chiesti con la Section Rendering API;
 * - "Scorrimento infinito": lo stesso caricamento parte da solo quando il pulsante si avvicina alla
 *   finestra (IntersectionObserver). Il pulsante resta, come ripiego e per la tastiera.
 *
 * Il pulsante è un link alla pagina successiva: senza JavaScript, o se la richiesta fallisce, si
 * naviga normalmente. Dopo un aggiornamento dei filtri (evento acf:updated) il pulsante è nuovo e
 * va osservato di nuovo.
 *
 * Wishlist.js collega i cuori dei preferiti solo al caricamento della pagina: le card arrivate dopo
 * (da qui o dai filtri) vengono collegate con la sua setupButtons, una volta sola ciascuna.
 */
(function () {
  'use strict';

  var HOLDER = '[data-acf-loadmore]';
  var LINK = '[data-acf-loadmore-link]';
  var loading = false;
  var observer = null;

  function bindWishlist(container) {
    if (typeof window.setupButtons !== 'function' || !container) return;
    var buttons = Array.prototype.filter.call(container.querySelectorAll('[button-wishlist]'), function (button) {
      if (button.hasAttribute('data-acf-wl')) return false;
      button.setAttribute('data-acf-wl', '');
      return true;
    });
    if (buttons.length) window.setupButtons(buttons);
  }

  function sectionId(element) {
    var section = element.closest('.shopify-section');
    return section ? section.id.replace('shopify-section-', '') : null;
  }

  function load(link, fromClick) {
    if (loading) return;

    var section = link.closest('.shopify-section');
    var holder = link.closest(HOLDER);
    var list = section && section.querySelector('.ProductList--grid');
    var id = sectionId(link);

    if (!list || !holder || !id || !window.fetch || !window.DOMParser) {
      location.href = link.href;
      return;
    }

    loading = true;
    link.classList.add('is-loading');
    link.setAttribute('aria-busy', 'true');

    var requestUrl = new URL(link.href, location.href);
    requestUrl.searchParams.set('section_id', id);

    fetch(requestUrl.toString(), { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nextList = doc.querySelector('.ProductList--grid');
        if (!nextList) throw new Error('markup');

        var firstNew = null;
        var fragment = document.createDocumentFragment();
        var appended = [];
        Array.prototype.slice.call(nextList.children).forEach(function (child) {
          var node = document.importNode(child, true);
          if (node.classList && node.classList.contains('Grid__Cell')) {
            node.setAttribute('data-acf-appended', '');
            if (!firstNew) firstNew = node;
          }
          appended.push(node);
          fragment.appendChild(node);
        });
        list.appendChild(fragment);
        appended.forEach(bindWishlist);

        var nextHolder = doc.querySelector(HOLDER);
        if (nextHolder) {
          holder.replaceWith(document.importNode(nextHolder, true));
        } else {
          holder.remove();
        }

        // Chi usa la tastiera continua dal primo prodotto aggiunto, non dall'inizio della pagina
        if (fromClick && firstNew) {
          var target = firstNew.querySelector('.ProductItem__Title a, a[href]');
          if (target) target.focus({ preventScroll: true });
        }

        loading = false;
        watch();
        document.dispatchEvent(new CustomEvent('acf:appended'));
      })
      .catch(function () {
        location.href = link.href;
      });
  }

  function watch() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }

    var holder = document.querySelector(HOLDER + '[data-acf-loadmore="infinite"]');
    if (!holder || !('IntersectionObserver' in window)) return;

    var link = holder.querySelector(LINK);
    if (!link) return;

    observer = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) load(link, false);
    }, { rootMargin: '0px 0px 600px 0px' });
    observer.observe(link);
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest(LINK);
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;

    event.preventDefault();
    load(link, true);
  });

  // Le card presenti al caricamento le collega già Wishlist.js: si segnano per non collegarle due volte
  function markInitial() {
    document.querySelectorAll('[button-wishlist]').forEach(function (button) {
      button.setAttribute('data-acf-wl', '');
    });
  }

  document.addEventListener('acf:updated', function () {
    bindWishlist(document.querySelector('.CollectionInner__Products'));
    watch();
  });
  document.addEventListener('shopify:section:load', watch);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      markInitial();
      watch();
    });
  } else {
    markInitial();
    watch();
  }
})();
